import { Tabs as T } from 'radix-ui';
import { type ReactNode } from 'react';

import { cx } from '@/lib/cx';

export interface Aba {
  valor: string;
  rotulo: ReactNode;
  conteudo: ReactNode;
  /** Contagem ou selo ao lado do rótulo. */
  extra?: ReactNode;
}

interface TabsProps {
  abas: readonly Aba[];
  valor?: string;
  aoMudar?: (valor: string) => void;
  className?: string;
  /** Rótulo acessível da lista de abas. */
  rotulo: string;
}

/** Abas com sublinhado que desliza (o indicador acompanha a aba ativa). */
export function Tabs({ abas, valor, aoMudar, className, rotulo }: TabsProps) {
  const inicial = abas[0]?.valor ?? '';
  return (
    <T.Root
      {...(valor === undefined ? { defaultValue: inicial } : { value: valor })}
      {...(aoMudar ? { onValueChange: aoMudar } : {})}
      className={cx('grid gap-4', className)}
    >
      <T.List
        aria-label={rotulo}
        className="flex gap-1 overflow-x-auto overflow-y-hidden border-b border-borda"
      >
        {abas.map((aba) => (
          <T.Trigger
            key={aba.valor}
            value={aba.valor}
            className={cx(
              'relative -mb-px flex items-center gap-1.5 whitespace-nowrap px-3 py-2 text-sm font-medium text-texto-suave',
              'border-b-2 border-transparent transition-colors duration-[var(--duracao-media)]',
              'hover:text-texto data-[state=active]:border-marca data-[state=active]:text-texto',
            )}
          >
            {aba.rotulo}
            {aba.extra}
          </T.Trigger>
        ))}
      </T.List>
      {abas.map((aba) => (
        <T.Content
          key={aba.valor}
          value={aba.valor}
          className="animate-surgir focus-visible:outline-none"
        >
          {aba.conteudo}
        </T.Content>
      ))}
    </T.Root>
  );
}
